export const DEFAULT_LAYOUT_TRANSLATION_MODULE_NAMES = [
  'chat',
  'gemShop',
  'homebase',
  'menu',
  'navbar',
  'notFound',
  'search',
  'dashboard',
  'gamification',
  'home',
  'onboarding',
  'highscore',
  'emailVerify',
  'registerAccount',
  'subscription',
  'imageAlt',
  'adminPanel',
  'tutorPanel',
  'studentPanel',
  'statistics',
  'home',
  'familyAccount',
  'referral',
  'systemUpdate',
]

export const COMMON_TRANSLATION_MODULE_NAMES = [
  'imageAlt',
  'curriculum',
  'footer',
  'generics',
  'errors',
  'campaign',
  'common',
  'bootcamp',
  'subscription',
  'chat',
  'chatAi',
  'userFeedback',
]
